import { Link, LinkProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const FooterLink = styled((props: LinkProps) => (
  <Link {...props} underline="hover" />
))(({ theme }) => ({
  // Add !important to overrides cookie settings button style
  fontSize: "16px !important",
  lineHeight: "1.5 !important",
  letterSpacing: 0,
  color: `${theme.palette.secondary.light} !important`,
  border: "unset !important",
  padding: "unset !important",
  "&:hover": {
    backgroundColor: "transparent !important",
  },
}));
